<template>
	<div class="fuel container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 py-0">
				<div class="row">
					<div class="col-md-12 mb-2">
						<h4>OVERVIEW SPKLU</h4>
					</div>
					<div class="col-md-4 mb-4" style="cursor: pointer;" @click="gotoPage('station')">
						<el-card class="box-card col-md-12 px-1" shadow="hover">
							<div class="text-left mb-4">
								<h5>Charging Station</h5>
							</div>
							<div>
								<div class="row">
									<div class="col-md-4 text-center">
										<div class="ds-tag-info">{{ reportdata?.data?.charging_station_status?.Total }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Total</span></div>
									</div>
									<div class="col-md-4 text-center">
										<div class="ds-tag-success">{{ reportdata?.data?.charging_station_status?.Available }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Available</span></div>
									</div>
									<div class="col-md-4 text-center">
										<div class="ds-tag-danger">{{ reportdata?.data?.charging_station_status?.Unvailable }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Unavailable</span></div>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.table" />
					</div>

					<div class="col-md-4 mb-4" style="cursor: pointer;" @click="gotoPage('chargebox')">
						<el-card class="box-card col-md-12" shadow="hover">
							<div class="text-left mb-4">
								<h5>Charge Box</h5>
							</div>
							<div>
								<div class="row">
									<div class="col-md-4 text-center">
										<div class="ds-tag-info">{{ reportdata?.data?.charge_box_status?.Total }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Total</span></div>
									</div>
									<div class="col-md-4 text-center">
										<div class="ds-tag-success">{{ reportdata?.data?.charge_box_status?.Connected }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Connected</span></div>
									</div>
									<div class="col-md-4 text-center">
										<div class="ds-tag-danger">{{ reportdata?.data?.charge_box_status?.Disconnected }}</div>
										<div class="rm-space-1 secondary-text subtitle-1"><span>Disconnected</span></div>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.table" />
					</div>

					<div class="col-md-4 mb-4" style="cursor: pointer;" @click="gotoPage('socket')">
						<el-card class="box-card col-md-12 pb-0" shadow="hover">
							<div class="text-left mb-2">
								<h5>Socket ({{ reportdata?.data?.socket_status?.Total }})</h5>
							</div>
							<div>
								<div class="row">
									<div class="col-md-4 text-center mb-2">
										<div class="fw-bolder text-success">{{ reportdata?.data?.socket_status?.Available }}</div>
										<div class="rm-space-1 secondary-text subtitle-2 "><span>Available</span></div>
									</div>
									<div class="col-md-4 text-center mb-2">
										<div class="fw-bolder text-danger">{{ reportdata?.data?.socket_status?.Unavailable }}</div>
										<div class="rm-space-1 secondary-text subtitle-2"><span>Unavailable</span></div>
									</div>
									<div class="col-md-4 text-center mb-2">
										<div class="fw-bolder text-warning">{{ reportdata?.data?.socket_status?.Faulted }}</div>
										<div class="rm-space-1 secondary-text subtitle-2"><span>Faulted</span></div>
									</div>
									<div class="col-md-4 text-center mb-0">
										<div class="fw-bolder text-primary">{{ reportdata?.data?.socket_status?.Preparing }}</div>
										<div class="rm-space-1 secondary-text subtitle-2"><span>Preparing</span></div>
									</div>
									<div class="col-md-4 text-center mb-0">
										<div class="fw-bolder text-warning">{{ reportdata?.data?.socket_status?.Charging }}</div>
										<div class="rm-space-1 secondary-text subtitle-2"><span>Charging</span></div>
									</div>
									<div class="col-md-4 text-center mb-0">
										<div class="fw-bolder text-success">{{ reportdata?.data?.socket_status?.Finishing }}</div>
										<div class="rm-space-1 secondary-text subtitle-2"><span>Finishing</span></div>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.table" />
					</div>

				</div>

				<div class="row">
					<div class="col-md-4">
						<el-card class="box-card col-md-12 px-1" shadow="hover">
							<div class="text-left mb-3">
								<h5>Station List</h5>
							</div>
							<div>
								<div class="row mb-1 ds-bg-item " v-for="item in stations?.data" :key="'st-'+item.Id"
									:class=" (item.IsActive == 1 ? ' ds-bg-item-success ':' ds-bg-item-danger ') +  ( activeStationId === item.Id ? ' active ': '')"
									@click="toggleActive(item.Id)">
									<div class="col">
										{{ item.SpkluName }}
									</div>
									<div class="col-auto">
										<el-tag :type=" item.IsActive ==1 ? 'success':'danger' " style="height: 25px;line-height: 25px;">{{ item.IsActive == 1 ? 'Available':'Unavailable' }} </el-tag>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.station" />
					</div>

					<div class="col-md-4" v-if="activeStationId !== null">
						<el-card class="box-card col-md-12 px-1" shadow="hover">
							<div class="text-left mb-3">
								<h5>ChargeBox List</h5>
							</div>
							<div>
								<div class="row mb-1 ds-bg-item" v-for="item in chargeboxes?.data" :key="'cb-'+item.Id"
									:class=" (item.StatusMesin == 'Connected' ? ' ds-bg-item-success ':' ds-bg-item-danger ') +  ( activeChargeBoxId === item.Id ? ' active ': '')"
									@click="toggleChargeBoxActive(item.Id)">
									<div class="col">
										{{ item.CBId }}
										<div class="subtitle-2">
											{{ (item.LastUpdate).split('.')[0] }}
										</div>
									</div>
									<div class="col-auto">
										<el-tag :type="item.StatusMesin == 'Connected' ? 'success':'danger'" style="height: 25px;line-height: 25px;">{{ item.StatusMesin }} </el-tag>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.chargebox" />
					</div>

					<div class="col-md-4" v-if="activeChargeBoxId !== null">
						<el-card class="box-card col-md-12 px-1" shadow="hover">
							<div class="text-left mb-3">
								<h5>Socket List</h5>
							</div>
							<div>
								<div class="row mb-1 ds-bg-item" v-for="item in sockets?.data" :key="'sc-'+item.Id" >
									<div class="col-auto">
										{{ item.SocketNumber }}
									</div>
									<div class="col secondary-text subtitle-2" style="margin-top:2px;">
										{{ (item.LastUpdate).split('.')[0] }}
									</div>
									<div class="col-auto">
										<el-tag :type="tagSocketStatus(item.StatusSocket)" style="height: 25px;line-height: 25px;">{{ item.StatusSocket }} </el-tag>
									</div>
								</div>
							</div>
						</el-card>
						<Loader v-if="loading.socket" />
					</div>

				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import { Config,Penanggalan,AxiosWithJar, FuelColor, Rainbow, Rainbow2 } from '@/utility.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Fuel from '@/components/page/Fuel.js'
import Footer from '@/views/Footer.vue'
import PieChart from '@/components/chart/Pie.js'
import Loader from '@/components/loader/Loader2.vue'

export default{
	extends: Fuel,
	components:{
		//ListItem,
		//ListCompare,
		//BarCard,
		//PieChart,
		Loader,
		Footer
	},
	data() {
		return {
            reportdata: 0,
			stations: [],
			chargeboxes: [],
			socket: [],
			stationwithnode: {},
			loading: {
				table: false,
				isSuccess: false,
				node: false,
				station: false,
				chargebox: false,
				socket: false,
			},

			activeStationId: null,
			activeChargeBoxId: null,
            isChildRoute: false,
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	computed: {

	},

    mounted() {
        this.hideNonChildren();
		this.getData();
		this.getStation();
		//this.getStationWithNode();
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/spklu';
        },
		getData() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/spklu/overview?'
			//
			//this.urlRequestParams += '&year='+this.year
			//this.urlRequestParams += '&month='+this.month

            this.loading.table = true;
			this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.reportdata = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.table = false;
				})
        },

		getStation() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/spklu/station?'

			//this.urlRequestParams += '&year='+this.year
			//this.urlRequestParams += '&month='+this.month

            this.loading.station = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					this.loading.isSuccess = true;
					this.stations = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.station = false;
				})
        },

		getChargeBox() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/spklu/chargebox?'

			this.urlRequestParams += '&station='+this.activeStationId
			//this.urlRequestParams += '&month='+this.month

            this.loading.chargebox = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.chargeboxes = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.chargebox = false;
				})
        },

		getSocket() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/spklu/socket?'

			this.urlRequestParams += '&station='+this.activeStationId
			this.urlRequestParams += '&chargeBoxId='+this.activeChargeBoxId
			//this.urlRequestParams += '&month='+this.month

            this.loading.socket = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.sockets = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.socket = false;
				})
        },

		getStationWithNode() {
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/spklu/stationwithnode?'
			//
			//this.urlRequestParams += '&year='+this.year
			//this.urlRequestParams += '&month='+this.month

            this.loading.node = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					//this.loading.isSuccess = true;
					this.stationwithnode = response.data;
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.node = false;
				})
        },

		tagSocketStatus(status) {
			let res = 'success';
			if(status == 'Available')
				res = 'success';
			else if(status == 'Unavailable')
				res = 'danger';
			else if(status == 'Faulted')
				res = 'danger';
			else if(status == 'Preparing')
				res = 'primary';
			else if(status == 'Charging')
				res = 'success';
			else if(status == 'Finishing')
				res = 'success';

			return res;
		},
		toggleActive(id) {
            // Toggle active state
            //this.activeStationId = this.activeStationId === id ? null : id;
			if (this.activeStationId === id) {
                // Do nothing if it's the same ID (to keep it selected)
                return;
            }
            // Otherwise, set the new active ID
            this.activeStationId = id;
			this.activeChargeBoxId = null;
			this.getChargeBox();
        },
		toggleChargeBoxActive(id) {
			if (this.activeChargeBoxId === id) {
                // Do nothing if it's the same ID (to keep it selected)
                return;
            }
            // Otherwise, set the new active ID
            this.activeChargeBoxId = id;
			this.getSocket();
		},
		gotoPage(page) {
			const urlWithParams = `${window.location.origin}/spklu/report?tab=${page}`;
			window.open(urlWithParams, '_blank');
		}
	}
}
</script>

<style>
.ds-tag-info {
	font-size: 1.875rem;
	font-weight:bold;
	color:#606266;
}

.ds-tag-success {
	font-size: 1.875rem;
	font-weight:bold;
	color:#67C23A;
}

.ds-tag-danger {
	font-size: 1.875rem;
	font-weight:bold;
	color:#F56C6C;
}

.secondary-text {
	color:#909399;
}

.rm-space-1 {
	margin-top:-8px;
}

.subtitle-1 {
	font-size:14px;
}

.subtitle-2 {
	font-size:12px;
}

.ds-bg-item {
	padding: 8px 0px;
	border-radius:4px;
	cursor:pointer;
	transition: background 0.3s ease, color 0.3s ease;
}

.ds-bg-item-success:hover {
	background: #67C23A;
	color: #fff;
}

.ds-bg-item-success.active {
    background: rgb(117, 222, 65); /* Change this to your desired active color */
    color: #fff; /* Maintain text color for active state */
}

.ds-bg-item-danger:hover {
	background: #F56C6C;
	color: #fff;
}

.ds-bg-item-danger.active {
    background: #f05252; /* Change this to your desired active color */
    color: #fff; /* Maintain text color for active state */
}
</style>
